"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tablePage = _interopRequireDefault(require("@/components/CommonForm/table-page"));
var _trackProcess = _interopRequireDefault(require("@/views/office/task/track-process"));
var _form = _interopRequireDefault(require("@/views/office/task/form"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "his-task-manager",
  components: {
    TrackProcess: _trackProcess.default,
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      dialogTrackShow: false,
      dialogTaskShow: false,
      queryParams: {},
      columns: [{
        label: '流程定义名称',
        prop: 'processDefinitionName'
      }, {
        label: '流程实例名称',
        prop: 'processInstanceName',
        showOverflowTooltip: true
      }, {
        label: '发起人',
        prop: 'startUserName'
      }, {
        label: '任务名称',
        prop: 'taskName'
      }, {
        label: '发起时间',
        prop: 'startTime'
      }, {
        label: '办理时间',
        prop: 'endTime'
      }, {
        label: '任务历时',
        prop: 'duration'
      }, {
        label: '操作',
        slot: 'action'
      }],
      taskObj: null,
      comName: null,
      formComponents: _form.default
    };
  },
  methods: {
    change: function change(e) {
      this.$forceUpdate();
    },
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    /**
     * 追踪
     * @param row
     */
    track: function track(row) {
      this.taskObj = _objectSpread({}, row);
      if (row.processInstanceId !== null) {
        this.comName = row.tableName + '-form';
        this.$nextTick(function () {
          this.dialogTrackShow = true;
        });
      }
    }
  }
};